<template>
  <div>
    <h4 class="question _margin-bottom-30">How much time in the day is someone at home?</h4>

    <div class="row">
      <div class="col-xs-6 col-md-3" v-for="item in houseUsageTypes">
        <radio-button v-model="quote.propertyUsage" :value="item.id" @change="onChoose"
          :error="$v.propertyUsage.$error">{{ item.label }}</radio-button>
      </div>
    </div>

    <uiv-alert type="danger" v-if="error">
      <b>Error</b> <br />
      {{ error }}
    </uiv-alert>

    <div class="card-footer">
      <div class="col-xs-6">
        <uiv-btn @click="onBack">Back</uiv-btn>
      </div>

      <div class="col-xs-6 text-right">
        <uiv-btn type="primary" @click="onGoToQuestion('next')">
          Next
        </uiv-btn>
      </div>
    </div>
  </div>
</template>

<script>
import RadioButton from '../../../../base/components/forms/RadioButton';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'PropertyUsage',
  data() {
    return {
      error: null
    };
  },
  props: {
    $v: Object
  },
  computed: {
    ...mapState({
      quote: ({ quote }) => quote,
      houseUsageTypes: ({ lookups }) => lookups.houseUsageTypes
    }),
    ...mapGetters({
      progress: 'quote_questions/progress'
    })
  },
  methods: {
    ...mapActions({
      goToQuestion: 'quote_questions/goToQuestion'
    }),
    onBack() {
      this.goToQuestion({ type: 'prev' });
      this.$store.dispatch('tracing/addAction', { name: 'Step', value: 'Property Type' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Back' });
      this.$store.dispatch('tracing/saveActions');
    },
    async onChoose(p) {
      this.$store.dispatch('tracing/addAction', { name: 'Step', value: 'Property Type' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Choose' });
      this.$store.dispatch('tracing/addAction', { name: 'Value', value: p });
      this.quote.propertyUsage = p;
      await this.$store.dispatch('tracing/saveActions');
    },
    async onGoToQuestion(type) {
      this.$v.propertyUsage.$touch();
      this.error = null;
      if (this.$v.propertyUsage.$invalid) return;

      this.$store.dispatch('tracing/addAction', { name: 'Step', value: 'Property Type' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Next' });
      await this.$store.dispatch('tracing/saveActions');

      const lastStep = await this.goToQuestion({ type });
      if (lastStep) {
        const error = await this.$store.dispatch('quote/newQuote', 'solar');
        this.error = error;
        if (!error) {
          this.$router.push({ name: 'quoteResults' });
        }
      }
    }
  },
  components: {
    RadioButton
  }
};
</script>

<style lang="scss">
.small {
  font-size: 12px;
}
</style>
